export default __webpack_public_path__ + "static/media/breadcum-errow.4336d457.svg";